import http from "./http";

//直播课程列表  /pc/liveCourseInfo/list
function liveCourseInfoList(data) {
    let url = `/api/pc/liveCourseInfo/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}`;
    return http.post(url, {})
}

//直播课程详情  /pc/liveCourseInfo/getLiveCourseDetail/{courseId}
function getLiveCourseDetail(courseId) {
    let url = `/api/pc/liveCourseInfo/getLiveCourseDetail/${courseId}`;

    return http.get(url)
}


//直播报名  /pc/liveCourseInfo/course/sign/up
function signUp(courseId) {
    let url = `/api/pc/liveCourseInfo/course/sign/up`
    const formdata = new FormData();
    formdata.append("courseId", courseId);

    return http.post(url, formdata)
}

//切换章节（换视频时候调用）   /pc/liveCourseInfo/switch/section/{sectionId}
function switchSection(sectionId) {
    let url = `/api/pc/liveCourseInfo/switch/section/${sectionId}`;
    return http.get(url)
}

//开启直播  /pc/liveCourseInfo/start/live/{sectionId}
function startLive(sectionId) {
    let url = `/api/pc/liveCourseInfo/start/live/${sectionId}`;
    return http.get(url)
}


//关闭直播  /pc/liveCourseInfo/over/live/{sectionId}
function overLive(sectionId) {
    let url = `/api/pc/liveCourseInfo/over/live/${sectionId}`;
    return http.get(url)
}

//获取直播报名列表  /pc/liveCourseInfo/course/signup/list
function signupLiveCourse() {
    let url = `/api/pc/liveCourseInfo/course/signup/list`;
    return http.get(url)
}

//获取直播状态  /pc/liveCourseInfo/course/signup/list
function liveCourseStatus(courseId) {
    let url = `/api/live/streams/describeLiveStreamsOnline?courseId=${courseId}`;
    return http.post(url)
}

//获取直播未开播时封面文案  /pc/dict/data/list
function dictText(dictType) {
    let url = `/api/pc/dict/data/list`;
    const formdata = new FormData();
    formdata.append("dictType", dictType);
    return http.post(url, formdata)
}
function systemDictText(dictType) {
    let url = `/api/system/dict/data/list/open`;
    const formdata = new FormData();
    formdata.append("dictType", dictType);
    return http.post(url, formdata)
}
//聊天室上传文件  /pc/jim/chatroom/upload/file
function chatroomUploadFile(file, courseId) {
    let url = `/api/pc/jim/chatroom/upload/file`;
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("courseId", courseId);
    return http.post(url, formdata)
}



export {
    liveCourseInfoList,
    getLiveCourseDetail,
    signUp,
    switchSection,
    startLive,
    overLive,
    signupLiveCourse,
    liveCourseStatus,
    dictText,
    chatroomUploadFile,systemDictText
};
